import React from "react";
import styles from "./styles.module.css";
import imgCard from "../../images/email-em-analise.png";

export const NovoCliente = () => {
  return (
    <section>
      <h1 className={styles.cardIform__title}>Sua proposta segue em análise!</h1>
      <div className={styles.cardInform__descript}>
        <span>Estamos fazendo a análise da sua proposta e logo retornaremos no seu e-mail cadastrado.</span>
      </div>
      <div>
        <img src={imgCard} alt="Imagem para exemplificar analise" className={styles.cardInform__img} />
      </div>
    </section>
  );
};

